import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextArea, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const BusinessAddressField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Business Address (Inc Postcode)</Typography>
      <TextArea
        className="w-full"
        placeholder="Enter Business Address"
        maxLength={128}
        hasError={!!errors.businessAddress}
        {...register("businessAddress")}
      />
      <ErrorMessage errors={errors} name="businessAddress" />
    </div>
  );
};
